export default __webpack_public_path__ + "static/cli_petrizzio-0b09f389afdf22524ea5fa3fae8951ff.png";